import { render, staticRenderFns } from "./BuildOverview.vue?vue&type=template&id=26171721&scoped=true&"
import script from "./BuildOverview.vue?vue&type=script&lang=js&"
export * from "./BuildOverview.vue?vue&type=script&lang=js&"
import style0 from "./BuildOverview.vue?vue&type=style&index=0&id=26171721&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26171721",
  null
  
)

export default component.exports